import { useRouter } from 'next/router';
import { ASK_PERCY_ROUTE, CHAT_SESSION_ROUTE } from '@/config/constants';

/**
 * Whether the route forces the chat to fullscreen regardless of the stored layout
 * mode. The Percy shell routes (`/ask-percy`, `/chat/[id]`) are the chat itself.
 * Shared so the docked slot and the layout banner both defer to it.
 */
const useChatWidgetLockedFullscreen = () => {
  const {
    pathname
  } = useRouter();
  return pathname === ASK_PERCY_ROUTE || pathname === CHAT_SESSION_ROUTE;
};
export default useChatWidgetLockedFullscreen;